module.exports = function(vars) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<li class="broadcast-item media">\n		<div class="media-left">\n        <div class="panel panel-default text-center date">\n            <div class="panel-heading month">\n                <span class="panel-title strong">\n										' +
__e( vars.scheduleMonth ) +
'\n                </span>\n            </div>\n            <div class="panel-body day">\n							' +
__e( vars.scheduleDay ) +
'\n            </div>\n						<div class="panel-footer day">\n							' +
__e( vars.scheduleTime ) +
'\n            </div>\n        </div>\n    </div>\n    <div class="media-body schedule">\n        <h4 class="media-heading">\n					';
 if ( !vars.title ){ ;
__p += '\n						' +
__e( vars.startTime ) +
'\n					';
 } else { ;
__p += '\n						' +
__e( vars.title ) +
'\n					';
 } ;
__p += '\n        </h4>\n        <p><a target="_blank" aria-label="Add to Google Calendar"\n					href="' +
__e( vars.googleCalenderLink ) +
'"><i class="fa fa-calendar-plus-o"></i> Calendar Reminder</a></p>\n    </div>\n</li>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/broadcast-list-item.ejs